import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { DataGridListStyle, HtmlTooltip } from "../../Theme";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { v4 as uuid } from "uuid";
import NoRecords from "../NoRecords";
import InfoIcon from "../../images/icons/InfoIcon.svg";
import ErrorOverlay from "../ErrorOverlay";

const drugCol: GridColDef[] = [
  {
    field: "description",
    headerName: "Drug Description",
    width: 250,
    cellClassName: "w50",
    headerClassName: "w50",
    renderCell: ({ row }) => (
      <>
        <Typography className="textwrap">
          <Typography component="div" variant="body2" color={"primary"}>
            {row?.description ?? "N/A"}{" "}
          </Typography>
          <HtmlTooltip
            placement="right"
            arrow
            title={<DrugDescTooltip row={row} />}
          >
            <IconButton className="tooltip">
              <img src={InfoIcon} alt="Tooltip" loading="lazy" />
            </IconButton>
          </HtmlTooltip>
        </Typography>
      </>
    ),
  },
  {
    field: "drugNameType",
    headerName: "Type",
    width: 70,
    cellClassName: "w10",
    headerClassName: "w10",
  },
  {
    field: "rxOtcCode",
    headerName: "Rx/OTC",
    width: 70,
    cellClassName: "w20",
    headerClassName: "w20",
  },
  {
    field: "formularyStatus",
    headerName: "Fmlry. Status",
    width: 250,
    cellClassName: "w25",
    headerClassName: "w25",
  },
  {
    field: "copay",
    headerName: "Copay",
    width: 250,
    cellClassName: "w25",
    headerClassName: "w25",
  },
];

export default function StepMedicationsList(props: any) {
  const { stepMedicationsList } = props;

  //const [loading, setLoading] = useState(false);
  //const [error, setError] = useState(false);

  // const getDrugPopulate = async (doubleClickedDrugData: any) => {
  //   try {
  //     setPopulateLoader(true);
  //     const bodyData = {
  //       prescriptionForm: {
  //         drugId: doubleClickedDrugData?.drugId,
  //         initQtyQualifierListFlag: "false",
  //         rxhubPBMUniqueId: passingBodyData?.rxhubPBMUniqueId,
  //         rxhubPBMUniqueIdOptions: passingBodyData?.rxhubPBMUniqueIdOptions,
  //         rxNumber: JSON.parse(sessionStorage.getItem("TabValue")!) ?? "1",
  //       },
  //       patientId: passingBodyData?.patientId,
  //       userDetails: {
  //         userId: "",
  //         doctorId: passingBodyData?.doctorId,
  //         onBehalfDoctorId: "",
  //         selectedClinicId: sessionStorage.getItem("clinicId"),
  //       },
  //     };
  //     const result = await DrugPopulate(bodyData);
  //     if (result?.data?.digitalRxStatusCode === 200) {
  //       setPopulateLoader(false);
  //       setDrugPopulateData(result?.data?.response);
  //       handleHidePopupClick();
  //       SetFree(!free);
  //     } else {
  //       setPopulateLoader(false);
  //       setDrugPopulateData([]);
  //     }
  //   } catch (er) {
  //     setPopulateLoader(false);
  //     setDrugPopulateData([]);
  //   }
  // };

  return (
    <Grid
      container
      item
      xs={12}
      spacing={0}
      alignItems="center"
      justifyContent="center"
    >
      <Grid item xs={12}>
        <DataGridListStyle>
          <DataGrid
            rows={stepMedicationsList ?? []}
            sortingOrder={["desc", "asc"]}
            columns={drugCol}
            autoHeight
            rowHeight={40}
            getRowId={(row) => row.drugId ?? uuid()}
            headerHeight={36}
            pageSize={10}
            disableSelectionOnClick
            autoPageSize
            rowsPerPageOptions={[10]}
            components={{
              NoRowsOverlay: NoRecords,
              NoResultsOverlay: NoRecords,
              ErrorOverlay: ErrorOverlay,
            }}
            onRowDoubleClick={({ row }) => {
              //getDrugPopulate(row);
              //setDrugDescShow(true);
            }}
          />
        </DataGridListStyle>
      </Grid>
    </Grid>
  );
}

function DrugDescTooltip(prop: any) {
  const { row } = prop;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Drug Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.drugName ? "Not Available" : row.drugName}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Drug Type:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.drugtype ? "Not Available" : row.drugtype}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Dose:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.strength ? "Not Available" : row.strength}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Dosage Form:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.doseForm ? "Not Available" : row.doseForm}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Route:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.route ? "Not Available" : row.route}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Instructions:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.instructions ? "Not Available" : row.instructions}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Dose Unit:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.strengthUnit ? "Not Available" : row.strengthUnit}
        </Typography>
      </Grid>
    </Grid>
  );
}
